import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Stack,
  IconButton,
  InputGroup,
  Form,
  Message,
  Table,
  InputNumber,
  toaster,
  SelectPicker
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';

interface RowDataProcess {
  id: string; // or number, depending on your data
  attributes: {
    Process: string;
    Price: number;
    Type: string;
    uom: string;
    level: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const ProcessMaster = () => {
  ////////////////  Function For 14 Start /////////////////
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const [process, setProcess] = useState({
    Process: '',
    Price: 0,
    Type: '',
    uom: '',
    level: ''
  });
  // Fetch Data from API Start
  const [processdata, setProcessdata] = useState<RowDataProcess[]>([]);
  const [disMSTPro, setDisMSTPro] = useState([]);
  const [isLoading14, setIsLoading14] = useState(false);
  const [page5, setPage5] = useState(1);
  const [isLoading6, setIsLoading6] = useState(false);
  const [processMeta, setProcessMeta] = useState<MetaData>();
  const [filterStatus12, setFilteredStatus12] = useState('Continue');
  const [editedRowIdsprocess, setEditedRowIdsprocess] = useState<string[]>([]);
  const [editedRowIdprocess, setEditedRowIdprocess] = useState<string>('');
  const [editedDataprocess, setEditedDataprocess] = useState<
    Record<string, Partial<RowDataProcess['attributes']>>
  >({});


  useEffect(() => {
    fetchData14();
  }, [page5]);
  const fetchData14 = async () => {
    if (isLoading14) {
      return;
    }
    setIsLoading14(true);
    const pageResponse = await fetch(
      `${globalIP}/api/mstprocesses?populate=*&pagination[page]=1&sort[0]=id`
    );
    const pageJson = await pageResponse.json();
    const allData = [];
    for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstprocesses?populate=*&pagination[page]=1&sort[0]=id`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);

      const response2 = await fetch(`${globalIP}/api/mstprocesses`);
      const pageJson2 = await response2.json();
      const allData2 = [];
      for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstprocesses?populate=*&pagination[page]=${page}`
        );
        const pageJson2 = await pageResponse.json();
        allData2.push(...pageJson2.data);
      }
      setDisMSTPro(allData2);
    }
    setProcessMeta(pageJson.meta);
    setProcessdata(allData);
    setIsLoading14(false);
  };
  const processInputRef = useRef(null);

  const handleEditRowprocess = rowData => {
    setProcess({ ...rowData.attributes });
    setEditedRowIdprocess(rowData.id);
    setEditedRowIdsprocess(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataprocess(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    const selectedType = rowData.attributes.Type;
    if (uomMapping[selectedType]) {
      setFilteredUOM(unittype.filter(u => uomMapping[selectedType].includes(u.value)));
    } else {
      setFilteredUOM(unittype); // Default to all UOMs if no mapping is found
    }
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };
  const resetProcess = () => {
    setProcess({
      Process: '',
      Price: 0,
      Type: '',
      uom: '',
      level: ''
    });
  };
  const handleCancelProcess = rowData => {
    resetProcess();
    setEditedRowIdsprocess('');
    setEditedRowIdprocess('');
  };
  const url14 = `${globalIP}/api/mstprocesses`;
  const submit14 = async e => {
    const trimmedprocess = process.Process?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

    if (trimmedprocess === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Process.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (specialCharPattern.test(trimmedprocess)) {
      toaster.push(
        <Message showIcon type="error">
          Process {trimmedprocess} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const { data: processN } = await axios.get(
          `${globalIP}/api/mstprocesses?filters[Process][$eqi]=${trimmedprocess}`
        );
        const existingHscode = disMSTPro.find(
          item => item.attributes.Process.toLowerCase() === trimmedprocess.toLowerCase()
        );

        if (processN.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              Process {trimmedprocess} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          e.preventDefault();
          const formData = new FormData();
          formData.append('data', JSON.stringify({ ...process, Process: trimmedprocess }));

          const response = await fetch(url14, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            await fetchData14();
            console.log(process);

            toaster.push(
              <Message showIcon type="success">
                Data Save Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }

      setProcess({
        Process: '',
        Price: 0,
        Type: '',
        uom: '',
        level: ''
      });
    }
  };

  const mattype = [
    // { label: 'Chief Material', value: 'cmaterial' },
    { label: 'Metal', value: 'cmaterial' },
    { label: 'Marble', value: 'mrmaterial' },
    { label: 'Wood Material', value: 'wmaterial' },
    { label: 'Accessories Material', value: 'amaterial' },
    { label: 'Packing Material', value: 'pmaterial' }
  ];

  const unittype = [
    { label: 'Sq ft', value: 'sqft' },
    // { label: 'cu ft', value: 'cuft' },
    { label: 'CFT', value: 'cft' },
    { label: 'CBM', value: 'cbm' },
    { label: 'KG', value: 'kg' },
    { label: 'Pcs', value: 'Pcs' },
    { label: 'Inch', value: 'Inch' }
  ];
  const uomMapping = {
    wmaterial: ['sqft', 'cft', 'Inch'],
    mrmaterial: ['sqft', 'cft', 'cbm', 'Inch'],
    cmaterial: ['kg', 'Pcs', 'Inch']
  };
  const priority = [
    { label: 'Primary', value: 'primary' },
    { label: 'Secondry', value: 'secondry' }
  ];
  const [filteredUOM, setFilteredUOM] = useState(unittype);
  //  Fetch Data from API End
  // const handleInputChange14 = (inputName, value, index) => {
  //   if (uomMapping[value]) {
  //     setFilteredUOM(unittype.filter(u => uomMapping[value].includes(u.value)));
  //   } else {
  //     setFilteredUOM(unittype); // Default: Show all UOMs
  //   }

  //   setProcess({ ...process, [inputName]: value });
  // };
  const handleInputChange14 = (inputName, value, index) => {
    // Update the UOM options based on the selected Type
    if (inputName === 'Type' && uomMapping[value]) {
      setFilteredUOM(unittype.filter(u => uomMapping[value].includes(u.value)));
    } else if (inputName === 'Type') {
      setFilteredUOM(unittype); // If Type is reset or has no mapping, show all UOMs
    }

    // Update the process state with the new value
    setProcess({ ...process, [inputName]: value });
  };
  const handleSaveRowProcess = async () => {
    try {
      if (!process) {
        console.error('Process data not found.');
        return;
      }

      // Ensure process.Process exists and is trimmed properly
      const updatedCategoryName = process?.Process?.trim() || '';

      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

      // Validation: Empty process name
      if (!updatedCategoryName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter a valid Process.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // Validation: Special character check
      if (specialCharPattern.test(updatedCategoryName)) {
        toaster.push(
          <Message showIcon type="error">
            Process "{updatedCategoryName}" should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // Check if process name already exists in Strapi
      const { data: updateprocessN } = await axios.get(
        `${globalIP}/api/mstprocesses?filters[Process][$eqi]=${updatedCategoryName}&filters[id][$ne]=${editedRowIdprocess}`
      );

      if (updateprocessN?.data?.length) {
        toaster.push(
          <Message showIcon type="warning">
            Process "{updatedCategoryName}" already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // Update request with trimmed process name
      const response = await fetch(`${globalIP}/api/mstprocesses/${editedRowIdprocess}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: { ...process, Process: updatedCategoryName } // Ensure trimmed value is sent
        })
      });

      if (response.ok) {
        // If API call is successful, update UI
        fetchData14();
        resetProcess('');
        setEditedRowIdprocess('');
        setEditedDataprocess(prevData => ({
          ...prevData,
          [editedRowIdprocess]: { ...process, Process: updatedCategoryName } // Ensure UI updates correctly
        }));
        setEditedRowIdsprocess(prevRowIds => [...new Set([...prevRowIds, editedRowIdprocess])]);
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data:', error);
    }
  };

  const [filteredUOMsMAT, setFilteredUOMsMAT] = useState({});
  ////////////////  Searching Start /////////////////
  const [searchQuery14, setSearchQuery14] = useState('');
  const handleSearch14 = value => {
    setSearchQuery14(value);
  };
  const [processFilterData, setProcessFilterData] = useState([]);

  useEffect(() => {
    const processFilterData = processdata
      .slice()
      .reverse()
      .filter(item => {
        const process = item.attributes.Process ? item.attributes.Process.toLowerCase() : '';
        return process.includes(searchQuery14.toLowerCase());
      });
    setProcessFilterData(processFilterData);
  }, [processdata, filterStatus12, searchQuery14]);
  ////////////////  Searching End /////////////////

  return (
    <>
      <Stack justifyContent="space-between" style={{ marginBottom: '10px' }} className="mstr-panel">
        <Stack spacing={5} className="mstr-panel1">
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>Process</b>
            </Form.ControlLabel>
            <Input
              id="Process"
              name="Process"
              autoComplete="off"
              ref={processInputRef}
              value={process && process.Process ? process.Process : ''}
              onChange={value => handleInputChange14('Process', value, 0)}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>Price</b>
            </Form.ControlLabel>
            <InputNumber
              step={null}
              id="Price"
              name="Price"
              value={process && process.Price ? process.Price : ''}
              onChange={value => handleInputChange14('Price', value, 0)}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>Type</b>
            </Form.ControlLabel>
            <SelectPicker
              data={mattype}
              id="Type"
              name="Type mstr-btn1"
              value={process && process.Type ? process.Type : ''}
              onChange={value => handleInputChange14('Type', value, 0)}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>UOM</b>
            </Form.ControlLabel>
            <SelectPicker
              data={filteredUOM}
              id="uom"
              name="uom mstr-btn1"
              value={process && process.uom ? process.uom : ''}
              onChange={value => handleInputChange14('uom', value, 0)}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>Level</b>
            </Form.ControlLabel>
            <SelectPicker
              data={priority}
              id="level"
              name="level mstr-btn1"
              value={process && process.level ? process.level : ''}
              onChange={value => handleInputChange14('level', value, 0)}
            />
          </Stack>
          {editedRowIdprocess ? (
            <Button
              appearance="primary"
              color="cyan"
              onClick={handleSaveRowProcess}
              className="mstr-btn"
              style={{ marginTop: '16px', marginRight: '5px' }}
            >
              {' '}
              Update
            </Button>
          ) : (
            <Button
              appearance="primary"
              color="cyan"
              onClick={submit14}
              className="mstr-btn"
              style={{ marginTop: '16px', marginRight: '5px' }}
            >
              {' '}
              Add
            </Button>
          )}
        </Stack>
        <Stack className="mstr-search" spacing={5} style={{ marginTop: '16px' }}>
          <InputGroup inside>
            <Input
              placeholder="Search"
              type="text"
              value={searchQuery14}
              onChange={handleSearch14}
            />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
      <Table
        rowHeight={60}
        data={processFilterData}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading6}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
        </Table.Column>
        <Table.Column width={130} flexGrow={1}>
          <Table.HeaderCell>
            <b>Process</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                rowData.attributes.Process
            }
          </Table.Cell>
        </Table.Column>

        <Table.Column width={150}>
          <Table.HeaderCell>
            <b>Type</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                mattype.find(item => item.value === rowData.attributes.Type)?.label ||
                rowData.attributes.Type
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={80}>
          <Table.HeaderCell>
            <b>UOM</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                (filteredUOMsMAT[rowData.id] || unittype).find(
                  item => item.value === rowData.attributes.uom
                )?.label || rowData.attributes.uom
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={80}>
          <Table.HeaderCell>
            <b>Price</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                rowData.attributes.Price
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100}>
          <Table.HeaderCell>
            <b>Level</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                priority.find(item => item.value === rowData.attributes.level)?.label ||
                rowData.attributes.level
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsprocess.includes(rowData.id) ? (
                <div>
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={handleCancelProcess}
                  />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowprocess(rowData)}
                  />
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <div>
        <p>
          <small>Total row:{processFilterData.length}</small>
        </p>
      </div>
    </>
  );
};

export default ProcessMaster;
